import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ReuseService implements RouteReuseStrategy {
    static storedRouteHandles = new Map<string, DetachedRouteHandle>();

    // Used to determine whether the router needs to be stored when navigating
    from = '';
    to = '';

    // Used to determine whether to read the previously stored router when navigating
    reuseFrom = '';
    reuseTo = '';

    static removeFromMap(url: string) {
        ReuseService.storedRouteHandles.delete(url);
    }

    shouldReuseRoute(from: ActivatedRouteSnapshot, to: ActivatedRouteSnapshot): boolean {
        if (from.routeConfig) {
            this.from = this.getPath(from);
        }
        if (to.routeConfig) {
            this.to = this.getPath(to);
        }
        return from.routeConfig === to.routeConfig;
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        // Judge if do store
        if (this.shouldStore()) {
            this.reuseFrom = this.to;
            this.reuseTo = this.from;
        }
        return this.shouldStore();
    }

    store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
        // Store router
        ReuseService.storedRouteHandles.set(this.getPath(route), detachedTree);
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        if (this.from === this.reuseFrom && this.to === this.reuseTo) {
            // Read reused router
            return (ReuseService.storedRouteHandles.get(this.getPath(route)) as DetachedRouteHandle) || null;
        } else {
            return null;
        }
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        if (this.reuseFrom && this.reuseTo && this.from && this.to) {
            return this.from === this.reuseFrom && this.to === this.reuseTo && ReuseService.storedRouteHandles.has(this.getPath(route));
        }

        return false;
    }

    private shouldStore() {
        const fromToMap = new Map([
            ['/order-management/order-list', '/order-management/order-detail'],
            ['/product-management/product-list', '/product-management/product-detail'],
        ]);
        return this.to === fromToMap.get(this.from);
    }

    private getPath(route: ActivatedRouteSnapshot): string {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        let url: string = route['_routerState'].url;

        if (url.startsWith('/order-management/order-detail')) {
            url = '/order-management/order-detail';
        }

        if (url.startsWith('/product-management/product-detail')) {
            url = '/product-management/product-detail';
        }

        return url.split('?')[0];
    }
}
